function setRem() {
    const _screen = document.documentElement.clientWidth;
    console.log(_screen)
    if(_screen < 1400){
        const baseSize = 16;
        const scale = 1400 / 1920;
        document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
    }else {
        const baseSize = 16;
        const scale = _screen / 1920;
        document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
        // document.documentElement.style.fontSize = 16 + 'px';
    }
}

setRem();

window.onresize = function() {
    setRem();
};
